import { ProductAddress } from '~/components/core/product/adapters/product-types';
import { QuoteAddress, QuoteRequirementSection } from './types/basket-types';
import { AddressCustomsFields } from '~/lib/types/customs';

export function formatAddress(address: QuoteAddress | ProductAddress) {
  const parts = [
    'contactname' in address ? address.contactname : address.contactName,
    `${address.property} ${address.street}`,
    address.town,
    address.postcode,
    typeof address.country === 'string' ? address.country : address.country.name
  ];
  return parts.filter(Boolean).join(', ');
}

export const getEditAddressTranslationKey = (key: string, name: string, country: string, type: string) => {
  if (name === 'Mobile') {
    return `ADDRESS_FIELD_${type}_MOBILE_LABEL`.toUpperCase();
  } else if (key === 'county' && country === 'SAU') {
    return `ADDRESS_FIELD_${type}_${key}_${country}_LABEL`.toUpperCase();
  } else {
    return `ADDRESS_FIELD_${type}_${key}_LABEL`.toUpperCase();
  }
};

export const getOverviewFieldsOrder = (country: string, forceSelection?: boolean) => {
  let fieldsOrder: string[] = ['contactname', 'organisation', 'property', 'town', 'county', 'postcode'];

  if (country === 'SAU') {
    fieldsOrder = ['contactname', 'county', 'organisation', 'property', 'town', 'postcode'];
  }

  if (forceSelection) {
    fieldsOrder = fieldsOrder.filter((field) => field !== 'contactname');
  }

  return fieldsOrder;
};

export const getEditFieldsOrder = (requirements: QuoteRequirementSection, country: string) => {
  let fieldsOrder: string[] = [
    'contactname',
    'organisation',
    'property',
    'street',
    'locality',
    'town',
    'county',
    'country',
    'postcode',
    'email',
    'phone'
  ];

  const fields = requirements.rules?.filter((x) => !AddressCustomsFields.includes(x.key));

  if (!fields) return [];

  const changeFieldsDispalyOrder = country === 'SAU';

  if (!changeFieldsDispalyOrder) {
    return fields;
  }

  if (country === 'SAU') {
    fieldsOrder = [
      'contactname',
      'county',
      'organisation',
      'property',
      'street',
      'locality',
      'town',
      'country',
      'postcode',
      'email',
      'phone'
    ];
  }

  return fields.sort((a, b) => {
    const aIndex = fieldsOrder.indexOf(a.key);
    const bIndex = fieldsOrder.indexOf(b.key);

    return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
  });
};
